import { render, staticRenderFns } from "./ProjectRoomComplete.vue?vue&type=template&id=05d3b45b&"
import script from "./ProjectRoomComplete.vue?vue&type=script&lang=js&"
export * from "./ProjectRoomComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports